export default class AutoPopulateAddress {
	constructor(args) {
		// Source inputs/selects
		this.inputSources = args.inputSources;

		// Where the full address will be displayed as text
		this.textTarget = args.textTarget;

		// Container for the full address
		this.textTargetContainer = args.textTargetContainer;

		// Elements which need to be hidden once the full address is displayed
		this.hideContainer = args.hideContainer;

		// The step in the process which triggers the address
		this.stepToTriggerPopulate = args.stepToTriggerPopulate;

		// Function/value to run before copying address to check if we should continue, returns true/false
		this.prePopulateCheck = args.prePopulateCheck;

		// Callback after address is populated
		this.onComplete = args.onComplete;

		// Edit the auto-populated address by showing manual fields
		this.editButton = args.editButton;

		this.hasShownManualAddress = false;

		this.bindEvents();
	}

	bindEvents() {
		$(this.stepToTriggerPopulate).on("show.bs.collapse", (e) => {
			this.onPopulateAddress(e, $(this.inputSources), this.textTarget);
		});

		$(this.editButton).on("click", this.onToggleManualAddress.bind(this));
	}

	onPopulateAddress(e, fields, textTarget) {
		console.log("AutoPopulateAddress.onPopulateAddress()");

		// Stop if check fails
		if(this.prePopulateCheck && !this.prePopulateCheck()) {
			return;
		}

		let text = [];

		fields.each((i, field) => {
			field             = $(field);
			const target      = $(field.data('copyTo'));
			const value       = field.val();
			const value2      = $(field.data('copyWith')).val() || "";
			const delimiter   = field.data('copyDelimiter') || "";
			const tomSelect   = target[0]?.tomselect ?? null;

			if(target.length && value != "") {
				target.val(value + (value2 != "" ? delimiter + value2 : ""));

				if(!field.data('copySkipText')) {
					text.push(target.val());
				}
			}

			if(value != "" && tomSelect != null) {
				tomSelect.addItem(value);
			}
		});

		if(textTarget) {
			$(textTarget).html(text.join(", ").replaceAll(/\, GB$/g,""));
		}

		const button = $(e.currentTarget);

		if(button) {
			$(button.data('reveal')).collapse('show');
			$(button.data('hide')).collapse('hide');
		}

		this.toggleContainers();

		if(this.onComplete) {
			console.log("AutoPopulateAddress.onComplete");
			this.onComplete();
		}
	}

	toggleContainers() {
		console.log("AutoPopulateAddress.toggleContainers", {hasShownManualAddress: this.hasShownManualAddress});

		// If we've already shown the manual address fields, resetting the containers gets a bit messy so best to leave as-is with the manual address fields visible
		if(this.hasShownManualAddress) {
			return;
		}

		if(this.textTargetContainer) {
			$(this.textTargetContainer).collapse('show');
		}

		if(this.hideContainer) {
			$(this.hideContainer).collapse('hide');
		}
	}

	onToggleManualAddress(e) {
		console.log("AutoPopulateAddress.onToggleManualAddress", $(e.currentTarget));
		let fields = $(e.currentTarget).data();
		$(fields['reveal']).collapse('show');
		$(fields['reveal']).find(".alert-red, .text-red").hide(); // Remove any errors that may have been in hidden div
		$(fields['reveal']).find(".is-invalid").removeClass("is-invalid"); // Remove any errors that may have been in hidden div
		$(fields['hide']).collapse('hide');
		$(fields['focus']).focus();

		this.hasShownManualAddress = true;
	}
}